import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const PanelExterior = () => {

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 2 }}
    >
      <VentoleraIzquierda  />
      <VentoleraDerecha  />
      <PanelIzquierdo  />
      <PanelDerecho  />
    </Grid>
  );
};

const VentoleraIzquierda = () => {
  const {
    open: openCierreContenedor1,
    handleClose: handleCloseCierreContenedor1,
    handleOpen: handleOpenCierreContenedor1,
  } = useOpen();

  const ventoleraIzquierdaPhoto = useWorkflowContainerFullStore(
    (state) => state.ventoleraIzquierdaPhoto 
  );

  const setVentoleraIzquierdaPhoto = useWorkflowContainerFullStore(
    (state) => state.setVentoleraIzquierdaPhoto
  );
  const fotoUrl = useBlobUrl(ventoleraIzquierdaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor1}
        handleOpen={handleOpenCierreContenedor1}
        label="VENTOLERA IZQUIERDA"
        open={openCierreContenedor1}
        setFoto={setVentoleraIzquierdaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const VentoleraDerecha = () => {
  const {
    open: openCierreContenedor2,
    handleClose: handleCloseCierreContenedor2,
    handleOpen: handleOpenCierreContenedor2,
  } = useOpen();

  const ventoleraDerechaPhoto = useWorkflowContainerFullStore(
    (state) => state.ventoleraDerechaPhoto
  );

  const setVentoleraDerechaPhoto = useWorkflowContainerFullStore(
    (state) => state.setVentoleraDerechaPhoto
  );
  const fotoUrl = useBlobUrl(ventoleraDerechaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor2}
        handleOpen={handleOpenCierreContenedor2}
        label="VENTOLERA DERECHA"
        open={openCierreContenedor2}
        setFoto={setVentoleraDerechaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const PanelIzquierdo = () => {
  const {
    open: openCierreContenedor3,
    handleClose: handleCloseCierreContenedor3,
    handleOpen: handleOpenCierreContenedor3,
  } = useOpen();

  const panelIzquierdoPhoto = useWorkflowContainerFullStore(
    (state) => state.panelIzquierdoPhoto
  );

  const setPanelIzquierdoPhoto = useWorkflowContainerFullStore(
    (state) => state.setPanelIzquierdoPhoto
  );
  const fotoUrl = useBlobUrl(panelIzquierdoPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor3}
        handleOpen={handleOpenCierreContenedor3}
        label="PANEL IZQUIERDO"
        open={openCierreContenedor3}
        setFoto={setPanelIzquierdoPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const PanelDerecho = () => {
  const {
    open: openCierreContenedor3,
    handleClose: handleCloseCierreContenedor3,
    handleOpen: handleOpenCierreContenedor3,
  } = useOpen();

  const panelDerechoPhoto = useWorkflowContainerFullStore(
    (state) => state.panelDerechoPhoto
  );

  const setPanelDerechoPhoto = useWorkflowContainerFullStore(
    (state) => state.setPanelDerechoPhoto
  );
  const fotoUrl = useBlobUrl(panelDerechoPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor3}
        handleOpen={handleOpenCierreContenedor3}
        label="PANEL DERECHO"
        open={openCierreContenedor3}
        setFoto={setPanelDerechoPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};
